<div class="position-absolute bottom-7 start-20">
  <app-scale-control> </app-scale-control>
</div>

<app-bottom-page-panel>
  <app-history-mode
    *hasPermissionAny="[Permissions.RCS_Historic_All_Read]"
    [isHistoryVisible]="isHistoryVisible"
    (historyToggled)="toggleHistory()"
    data-cy="historic-view-toggle"
  ></app-history-mode>
  <app-auto-refresh
    (intervalSet)="setLiveModeRefreshInterval($event)"
    [isActive]="isInLiveMode"
    [isDisabled]="isHistoryVisible"
    [intervalInSecondsInput]="displayRefreshInterval"
  ></app-auto-refresh>
</app-bottom-page-panel>

<app-bwc-layer-config [providerInfo$]="this.ProviderInfo$"></app-bwc-layer-config>
<app-bwc-legend *ngIf="isLegendVisible" [providerInfo$]="this.ProviderInfo$"></app-bwc-legend>
<app-bwc-details></app-bwc-details>
<app-bwc-raw-details></app-bwc-raw-details>
<app-bwc-details-weather></app-bwc-details-weather>
<app-map-navigation>
  <app-bwc-view-actions-bar
    [isLegendVisible]="isLegendVisible"
    [isWebcamLayerVisible]="isWebcamLayerVisible"
    (toggleLegend)="toggleLegend()"
    (toggleWebcamLayer)="toggleWebcamLayer()"
  ></app-bwc-view-actions-bar>
</app-map-navigation>
<app-bwc-history-control
  (historyClosed)="handleHistoryClosed()"
  *ngIf="isHistoryVisible"
></app-bwc-history-control>
<app-last-backend-call></app-last-backend-call>
